
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'

export interface OnboardingStatus {
    agent_page_tour_seen: boolean;
    phone_page_tour_seen: boolean;
    buy_page_tour_seen: boolean;
    knowledgebase_tour_seen: boolean;
    knowledgebase_page_tour_seen: boolean;
}

export interface UserProfile {
    accountId: number;
    email: string;
    phoneNumber: string;
    firstName: string;
    id: number;
    isAdmin: 0 | 1 | 2;
    isOnline: boolean;
    isVerified: boolean;
    lastName: string;
    profilePicture: string | null;
    timezone: {
        id: number;
        name: string;
        zone: string;
        utc: string;
    };
    unavailabilityReasonId: number | null;
    unavailabilityReasons: {
        reason: string;
        id: number;
    }[];
    onboardingStatus?: OnboardingStatus;
}

interface UserState {
    user: UserProfile | null;
    setUser: (user: UserProfile | null) => void;
    updateUser: (data: Partial<UserProfile>) => void;
    setOnboardingStatus: (status: Partial<OnboardingStatus>) => void;
}

export const useUserStore = create<UserState>()(
    persist(
        (set) => ({
            user: null,
            setUser: (user) => set({ user }),
            updateUser: (data) => set((state) => ({
                user: state.user ? { ...state.user, ...data } : null
            })),
            setOnboardingStatus: (status) => set((state) => {
                if (!state.user) return { user: null };
                const currentStatus = state.user.onboardingStatus || { agent_page_tour_seen: false };
                return {
                    user: {
                        ...state.user,
                        onboardingStatus: { ...currentStatus, ...status } as OnboardingStatus
                    }
                };
            }),
        }),
        {
            name: 'user-storage', // name of the item in storage (must be unique)
            storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
        }
    )
)

